import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { AbstractPresetListComponent } from '../../../../../shared/crud/component/preset-list.component';
import { EventBus } from '../../../../../shared/event/bus';
import { MailType } from '../../../../mailing/shared/enum/mail-type';
import { AdminUrlBuilder } from '../../../../../shared/admin/api/admin-url-builder';
import { Subscription } from 'rxjs';
import { ISelectOption } from '../../../../../shared/form/element/base-select/select-option.interface';
import { ErrorCodes } from '../../../../../shared/enum/api-errors';

@Component({
  selector: 'admin-mail-template-list',
  templateUrl: './list.component.html',
  styleUrls: [ './list.component.scss' ]
})
export class AdminMailTemplateListComponent extends AbstractPresetListComponent implements OnInit {

  mailTypes: any = MailType;
  mailTypesArray: string[] = Object.keys(MailType); // .filter((m: any) => MailType[m].forAdmin);
  selectedRowId: number = 0;
  templatesGrouped = {};
  vars: { [key: string]: ISelectOption[] };

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              urlBuilder: AdminUrlBuilder,
              eventBus: EventBus,
              changeDetector: ChangeDetectorRef,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route, urlBuilder, eventBus, changeDetector);
  }

  getResourceUrl(): string {
    return '/template';
  }

  ngOnInit() {
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Templates',
      url: '/mailing/template'
    });

    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  load(): Subscription {
    this.loading = true;
    this.loadingPromise = this.fetchRemoteSource().subscribe();
    this.loadingPromise.add(() => {
      this.loading = false;
      this.templatesGrouped = Object.assign({}, ...Object.keys(this.mailTypes).map(type => {
        const templatesOfType = this.pagination.rows.filter(row => row.type === type);
        return { [type]: templatesOfType };
      }));
        this.httpClient.get(this.urlBuilder.buildUrl(`/template-vars`))
            .subscribe(
                (data: {[name: string]: {[key: string]: {name: string; description: string;} }}) => {
                    const vars: { [key: string]: ISelectOption[] } = {};
                    Object.keys(data).forEach((name) => {
                        vars[name] = Object.keys(data[name]).map((key) => ({
                            label: data[name][key].description,
                            value: key,
                        }));
                    });
                    this.vars = vars;
                }
            );
    });
    return this.loadingPromise;
  }

  onAdd(type) {
    const newRow = {
      id: undefined,
      name: 'Template #',
      type: type,
      isDefault: false,
    };

    this.templatesGrouped[type].push(newRow);
  }


  onMakeDefault(rowId) {
    this.selectedRowId = rowId;
    this.loading = true;
    this.makeDefault(rowId);
  }

  onDelete(rowId) {
    if (!rowId) {
      this.load();
    } else {
      this.delete(rowId);
    }
  }

  makeDefault(id): Subscription {
    return this.httpClient.put(this.urlBuilder.buildUrl(this.getResourceUrl() + '/' + id + '/default'), { isDefault: true })
      .subscribe(
        (response: any) => {
          this.load();
        },
        (error: any) => {
          this.loading = false;
          this.toastrService.error('Failed to change default settings');
        }
      );
  }

  makeNoDefault(): Subscription {
    const defaultRow = this.pagination.rows.find(r => r.isDefault);
    if (defaultRow) {
      const url = this.urlBuilder.buildUrl(`${this.getResourceUrl()}/${defaultRow.id}/default`);
      return this.httpClient.put(url, {
        isDefault: false,
      }).subscribe((response: any) => {
        defaultRow.isDefault = false;
        this.toastrService.success('Saved');
        return response;
      }, (error: any) => {
        this.toastrService.error(error.error ? (error.error.message || ErrorCodes[error.error.code] || 'Something went wrong...') : 'Error');
        return error;
      });
    }
  }

}
